export default function RequisitionIcon() {
    return (
        <svg width="157" height="220" viewBox="0 0 157 220" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M154.281 57.6562L99.5938 2.96875C98.0313 1.40625 96.4688 0.625 94.125 0.625H16C7.40625 0.625 0.375 7.65625 0.375 16.25V203.75C0.375 212.344 7.40625 219.375 16 219.375H141C149.594 219.375 156.625 212.344 156.625 203.75V63.125C156.625 60.7812 155.844 59.2188 154.281 57.6562ZM94.125 19.375L137.875 63.125H94.125V19.375ZM141 203.75H16V16.25H78.5V63.125C78.5 71.7188 85.5312 78.75 94.125 78.75H141V203.75Z" fill="white" />
        </svg>
    )
}